module.exports = __webpack_public_path__ + "img/check_with_green_placeholder_background.9911276d.svg";